"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intoBaseDocument = intoBaseDocument;
const lodash_1 = require("lodash");
const constants_1 = require("./constants");
/**
 * Convert a document into its "base" representation by removing certain data.
 * In particular, we remove data that is not intended to be serialized along
 * with metadata such as the document owner, latest update timestamp, etc - and
 * in general (but not exclusively!) these are the "subcollections" on the
 * document such as pcbLayoutNodes, which are represented in a distinct
 * collection on the backend.
 *
 * QUESTION: should selectedObjectUids be omitted here also?
 *
 * QUESTION: should layerViewConfig really be ommitted here? The problem with
 * that object is that it is updated outside of autosave (see
 * PcbLayerViewStore), and we don't want autosave to overwrite it after the
 * autosave delay, but we do want it be included in the document when it is
 * loaded, which it is, despite the IBaseDocumentData typing.
 *
 * QUESTION: Should counts like comment_count be omitted here? They are
 * currently updated in the backend by cloud function, not by the frontend. So,
 * in theory, stale counts could be saved.
 */
function intoBaseDocument(document) {
    // QUESTION: why is cloneDeep needed here? it costs significant memory and time
    // ANSWER: this cloneDeep is needed because DocumentStorage keeps a cache of the
    // state of the previously saved document (in DocumentStorage.updateLocalLastSavedDocumentCache)
    // but doesn't take responsibility for deep cloning the data itself. Later, it gives this cached
    // version of the document to DocumentRepository.save, where it is compared with isEqual
    // to decide whether the base document needs to be saved (that code predates removing
    // several objects from the base document below with omit). So, without the deepClone, any objects
    // on the documentData that were being mutated would be mutated on both the new and cached
    // copies, so the diff checking with isEqual would report no changes, even though there were
    // changes to the base document that needed saving.
    return (0, lodash_1.cloneDeep)((0, lodash_1.omit)(document, "latestPatch", "layerViewConfig", "subDocumentData", // sub-document data is managed separately via snapshots
    "__metadata", // filter out accidental mixing of snapshot metadata
    ...constants_1.documentSubcollectionFields));
}
//# sourceMappingURL=base.js.map